import { graphql } from 'gql.tada';

export const GET_PROGRAM_CATEGORIES = graphql(`
    query GetProgramCategories {
        categories(contentType: PROGRAM) {
            id
            title
        }
    }
`);

export const GET_PROGRAM_CATEGORY_DETAILS = graphql(`
    query GetProgramCategoryDetails {
        categories(contentType: PROGRAM) {
            id
            title
            catchPhrase
            image
        }
    }
`);

export const GET_FORMAT_CATEGORIES = graphql(`
    query GetFormatCategories {
        categories(contentType: FORMAT) {
            id
            title
        }
    }
`);
